import styled from "@emotion/styled"
import { Switch, SwitchProps } from "@mui/material"
import { FC } from "react"

// Стилизованный Switch
const StyledSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "var(--white)",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--Schemes-Primary)",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "var(--Schemes-Primary)",
      border: "6px solid var(--white)",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: "var(--white)",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box" as const,
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "var(--unselected-text)",
    opacity: 1,
  },
}))

// Прокидываем все стандартные пропсы Switch
const IOSSwitch: FC<SwitchProps> = (props) => {
  return <StyledSwitch {...props} />
}

export default IOSSwitch
